import { capitalizeAllIfLower, capitalizeIfLower } from '@btime/helpers'
import { compose, pathOr, curry } from 'ramda'
import React from 'react'

import Text, { SmallText } from '../../../../packages/kiti/components/presentation/Text'
import { UserAvatar } from '../../../../components/presentation/Avatar'
import { Grid } from '../../../../packages/kiti/components/structure/Grid'
import IconText from '../../../../components/presentation/IconText'
import Panel from '../../../../components/structure/Panel'
import Separator from '../../../../components/helpers/Separator'

const capitalizePath = curry((capFunc, fields, item) => compose(capFunc, pathOr('', fields))(item))

const UserCard = ({ item }) => {
  const groupName = capitalizePath(capitalizeIfLower, ['contract', 'group', 'name'], item)
  const email = capitalizePath(capitalizeIfLower, ['email'], item)
  const userName = capitalizePath(capitalizeAllIfLower, ['name'], item)
  const profileName = capitalizePath(capitalizeAllIfLower, ['contract', 'profile', 'name'], item)

  return (
    <Panel smallPadding>
      <Grid justify="flex-start" gap={0.4} align="center">
        <UserAvatar size="small" user={item || {}} />
        <Text bold size="h3" color="dark1">
          {userName}
        </Text>
      </Grid>

      <Separator weight={4} />

      {!!groupName && (
        <IconText
          left
          color="dark3"
          iconName="BsPeopleFill"
          label={groupName}
          iconSize="1rem"
          size="p"
          separatorWeight={3}
        />
      )}

      {!!email && (
        <IconText left color="dark3" iconName="BsEnvelope" label={email} iconSize="1rem" size="p" separatorWeight={3} />
      )}

      <Separator weight={4} />

      <SmallText bold color="dark2">
        {profileName}
      </SmallText>
    </Panel>
  )
}

export default UserCard
